import React, {useEffect} from "react";
import NavBar from "../../components/Navbar";
import styles from "../../styles/screens/Privacypolicy.module.css";
import Footer from "../../components/Footer";
import { useTranslation } from "react-i18next";
import { usePostHog } from 'posthog-js/react'
import Metadata from "../../components/metadata/MetaData";

const TermsAndConditions = () => {
  const { t } = useTranslation();
  const posthog = usePostHog();

  useEffect(() => {
    posthog.capture('$pageview');
  }, [posthog]);


  return (
    <div>
      <Metadata
        description="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        keywords="Vrindavan Holi Prasad, Online Prasad Booking, Banke Bihari Holi Prasad, Holi 2025 Prasad, Braj Holi Offerings, Krishna Temple Prasad, Mathura Holi Prasad, Divine Prasad Home Delivery, Holi Blessings, Radha Krishna Holi, Spiritual Holi Traditions, Gulaal Offerings, Holi Bhog, Holi Prasad Service, Order Prasad Online, Holi Rituals in Vrindavan, Holi Puja Offerings, Buy Banke Bihari Prasad Online, Order Banke Bihari Temple Prasad, Online Banke Bihari Prasad Delivery, Vrindavan Holi Prasad Online, Holi Prasad Box Online, Sacred Holi Prasad Delivery, Banke Bihari Holi Prasad Box, Vrindavan Temple Prasad Online, Online Prasad from Banke Bihari Mandir, Buy Vrindavan Prasad Online for Holi, Holi Festival Offerings from Vrindavan, Krishna Bhog Prasad Online, Temple Prasad Home Delivery for Holi, Authentic Vrindavan Prasad Box, Online Delivery of Holi Prasad in India, Holi Special Prasad from Vrindavan Temples, Order Sacred Prasad from Vrindavan Temples, Banke Bihari Mandir Holi Offerings Online, Holi Prasad Gift Box from Vrindavan, Vrindavan Devotional Prasad for Holi, Mathura Holi, Mathura Holi 2025, Mathura Holi Dates 2025, Vrindavan Holi 2025, Barsana Holi 2025, Mathura Vrindavan Holi 2025, Brij Holi, Barsana Holi, Nandgaon Holi, Gokul Holi, Mahavan Holi, Goverdhan Holi, Holi, Huranga Holi, Vrindavan Holi, Brindavan Holi, Mathura Holi Calendar, India Holi, Braj Holi 2025 Schedule, Mathura Holi Schedule 2025, Holi Schedule, Colorful Festival Mathura Vrindavan, Bankey Bihari Temple Holi, Krishna Janmabhoomi Temple Holi, Lathmar Holi, Barsana Lathmar Holi, Phoolan Holi, Holi Festival Braja, Holi Celebration in Vrindavan, Charity on Holi, Holi Rituals, Lord Krishna Holi, Spring Festival, Spiritual Holi Celebration, Holi Charity Significance, Vrindavan Holi Traditions, Colors of Holi, Holi in Braja, Vrindavan Festival, Holi Prayers, Holi in Braja Region, Vrindavan Holi Customs, Holi Dance and Music, Holi Festivities in Vrindavan, Holi Community Celebrations, Holi in the Birthplace of Krishna, Holi Devotional Activities, Holi Festival of Love, Charity and Holi, Holi Color Festival, Devotional Holi Celebration, Vrindavan Holi Atmosphere, Holi in the Land of Krishna, Holi Worship and Prayers, Phool Wali Holi, Radha Krishna Holi, Widow's Holi, Holi in Mathura, Holi Traditions, Laddu Mar Holi, Holika Dahan, Dhulandi Holi, Holi Celebrations in India, Braj Region Holi, Krishna Holi Festival, Unique Holi Traditions, Holi Rituals in Braj."
        ogTitle="Order Vrindavan Holi Prasad Online | Banke Bihari Temple Offerings for Holi 2025"
        ogDescription="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        ogImage="https://d3vqmpzcil03dt.cloudfront.net/webite-assets/dharmik_logo.png"
        ogUrl="https://dharmikapp.in/dharmikx"
        canonicalUrl="https://dharmikapp.in/dharmikx"
        twitter="@dharmikapp"
        youtube="@dharmik_hindi"
        instagram="@dharmik_app"
        author="Dharmik App"
        publisher="Dharmik"
        datePublished="2025-03-08"
       />
      <NavBar />
      <div className={styles.privacy_policy_text}>
        <h1>{t("Dharmik App Terms of Use")}</h1>
        <p>
          <strong>{t("termsAndConditions.notice")}</strong>
        </p>

        <p>
          <strong>{t("termsAndConditions.introductionTitle")}</strong>
        </p>
        <p>{t("termsAndConditions.introductionContent")}</p>
        <p>{t("termsAndConditions.section1_2")}</p>
        <p>{t("termsAndConditions.section1_3")}</p>
        <p>{t("termsAndConditions.section1_4")}</p>

        <p>
          <strong>{t("termsAndConditions.overviewTitle")}</strong>
        </p>
        <p>{t("termsAndConditions.overviewContent")}</p>

        <p>
          <strong>{t("termsAndConditions.acceptanceTitle")}</strong>
        </p>
        <p>{t("termsAndConditions.acceptanceContent")}</p>

        <p>
          <strong>{t("termsAndConditions.accessTitle")}</strong>
        </p>
        <p>{t("termsAndConditions.accessContent1")}</p>
        <p>{t("termsAndConditions.accessContent2")}</p>

        <p>
          <strong>
            {t("termsAndConditions.registrationAndEligibilityTitle")}
          </strong>
        </p>
        <p>{t("termsAndConditions.registrationAndEligibilityContent1")}</p>
        <p>{t("termsAndConditions.registrationAndEligibilityContent2")}</p>
        <p>{t("termsAndConditions.registrationAndEligibilityContent3")}</p>
        <p>{t("termsAndConditions.registrationAndEligibilityContent4")}</p>
        <p>{t("termsAndConditions.registrationAndEligibilityContent5")}</p>

        <p>
          <strong>
            {t("termsAndConditions.registrationAndEligibilityTitle")}
          </strong>
        </p>
        <p>
          <strong>{t("termsAndConditions.yourResponsibilitiesTitle")}</strong>
        </p>
        <p>{t("termsAndConditions.yourResponsibilitiesIntro")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent1")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent2")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent3")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent4")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent5")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent6")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent10")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent11")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent12")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent14")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent15")}</p>
        <p>{t("termsAndConditions.yourResponsibilitiesContent16")}</p>

        <p>
          <strong>{t("termsAndConditions.paymentTermsTitle")}</strong>
        </p>
        <p>{t("termsAndConditions.paymentTermsContent")}</p>

        <p>
          <strong>
            {t("termsAndConditions.cancellationAndRefundPolicyTitle")}
          </strong>
        </p>
        <p>{t("termsAndConditions.cancellationAndRefundPolicyContent1")}</p>
        <p>{t("termsAndConditions.cancellationAndRefundPolicyContent2")}</p>
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
